import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { UploadLivroRequest } from '../../requests/platform/upload-livro.request';
import { UploadLivroResponse } from '../../responses/platform/upload-livro.response';

@Injectable({
  providedIn: 'root',
})
export class BookUploadService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public upload(request: UploadLivroRequest): Observable<UploadLivroResponse> {
    const url: string = environment.urlApiPlatform + 'BookUpload';
    return this.httpClient
      .post<UploadLivroResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}